import { useEffect, useState } from "react";
import MainLayout from "../../layout";
import { tablesListApi } from "../../redux/apis/table-apis";
import { Link, useNavigate } from "react-router-dom";

function TableItemGrid({ item }) {
    return (
        <Link
            key={item.id}
            to={`/pos/table-details/${item.id}`}
            className="cursor-pointer bg-white border border-gray-200 rounded-2xl shadow-sm p-4 hover:shadow-md hover:border-indigo-300 transition"
        >
            {/* Header: Name + Status */}
            <div className="flex justify-between items-center mb-2">
                <h2 className="text-lg font-semibold text-gray-800">
                    {item.name}
                </h2>
                <span
                    className={`px-3 py-1 text-xs font-medium rounded-full ${
                        item.status === "active"
                            ? "bg-green-100 text-green-700"
                            : "bg-gray-100 text-gray-600"
                    }`}
                >
                    {item.status}
                </span>
            </div>

            {/* Location */}
            <p className="text-sm text-gray-500 mb-3">📍 {item.location}</p>

            {/* Orders */}
            {item.orders && (
                <div>
                    <p className="text-sm text-gray-600">Total Before Tax</p>
                    <p className="text-xl font-bold text-indigo-600">
                        ₹{item.orders.total_before_tax}
                    </p>
                </div>
            )}
        </Link>
    );
}

const TableList = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [tables, setTables] = useState([]);
    var fetchTables = async () => {
        setLoading(true);
        try {
            var res = await tablesListApi();
            console.log("res", res);

            if (res.status == 200) {
                var tablesArr = [];
                tablesArr = [...res.data.data];
                setTables([...tablesArr]);
            } else {
            }
        } catch (error) {}

        setLoading(false);
    };
    useEffect(() => {
        fetchTables();
    }, []);

    return (
        <MainLayout>
            <p>Tables</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                {tables.map((item, index) => {
                    return <TableItemGrid item={item} />;
                })}
            </div>
                   <button
                        onClick={() => {
                            // confirmItems();
                            navigate("/pos/parcel-add-items")
                        }}
                        disabled={loading}
                        className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold"
                    >
                        Parcel / Just Billing
                    </button>
        </MainLayout>
    );
};

export default TableList;
